import { cloneElement, forwardRef } from "react";
import { useMergeRefs } from "sprout-hooks";
import composeEventHandlers from "../utils/composeEventHandlers";
export const PopoverTrigger = /*#__PURE__*/ forwardRef(function PopoverTriggerForwardRef(props, ref) {
    const { children , setTriggerElement , onOpenToggle , disabled  } = props;
    const mergedRefs = useMergeRefs(setTriggerElement, ref);
    return /*#__PURE__*/ cloneElement(children, {
        ref: mergedRefs,
        onClick: composeEventHandlers(children.props.onClick, disabled ? undefined : onOpenToggle)
    });
});
